import PropTypes from 'prop-types';
import React from 'react';
import { Navigate } from 'react-router-dom';

const ShouldRedirect = function ({ user, partner, children }) {
  if (user.hasRole('superGuuru', partner.id)) {
    return <Navigate replace to="/tasks" />;
  }

  if (user.uid && user.partnerIdsWithRoles.length === 0 && !user.isSuperAdmin) {
    return <Navigate replace to="/signup/complete" />;
  }
  return children;
};

ShouldRedirect.propTypes = {
  user: PropTypes.shape({
    hasRole: PropTypes.func,
  }),
  partner: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export default ShouldRedirect;
